import { z } from 'zod';

export const featureFlagsVersionType = z.enum(['v1', 'v2', 'unknown']);

export const FeatureFlags = z.object({
  bulkPdf: z.boolean(),
});

export const FeatureFlagsModel = z.object({
  features: FeatureFlags.partial(),
  version: featureFlagsVersionType,
});
